import { BaseState } from '@ilteducation/content-registry-types/enums/content-enums';
import mediaProvider from '@/data-provider/mediaProvider';

export default {
  data() {
    return {
      isFormEdited: false,
      availableStatesForPublishButton: [BaseState.Published, BaseState.Disabled],
      toggleStateInProgress: false,
      uploadInProgress: false,
    };
  },
  computed: {
    saveButtonAvailable() {
      if (this.isCloneMode) {
        return true;
      }

      // Save button is active if form is in "edit" mode or its data has been changed
      return this.isFormEdited || !this.item;
    },
    publishButtonAvailable() {
      if (this.isCloneMod) {
        return false;
      }

      return this.availableStatesForPublishButton.includes(this.item?.state);
    },
    isCloneMode() {
      const urlParams = new URLSearchParams(window.location.search);
      return !!urlParams.get('source');
    },
    statusColor() {
      switch (this.item?.state) {
        case BaseState.Published:
          return 'green';
        case BaseState.Disabled:
          return 'red';
        default:
          return 'yellow';
      }
    },
  },
  mounted() {
    this.isFormEdited = false;
  },
  methods: {
    async uploadMedia(id, data) {
      this.uploadInProgress = true;
      await mediaProvider.uploadMedia(id, data);
      this.uploadInProgress = false;
    },
    async toggleMediaState() {
      const isPublished = this.item.state === BaseState.Published;
      this.toggleStateInProgress = true;
      await mediaProvider
        .toggleMediaState(this.id, isPublished)
        .then(() => {
          // eslint-disable-next-line vue/no-mutating-props
          this.item.state = isPublished ? BaseState.Disabled : BaseState.Published;
        })
        .then(() => {
          this.toggleStateInProgress = false;
        });
    },
    getStateColor(state) {
      switch (state) {
        case BaseState.Published:
          return 'green';
        case BaseState.Disabled:
          return 'red';
        default:
          return 'yellow';
      }
    },
  },
};
